var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.datas)?_c('K-Loading',{attrs:{"Loading":_vm.Loading}}):_c('section',{staticClass:"box"},[_c('div',{staticClass:"title",domProps:{"textContent":_vm._s(_vm.datas.product.name)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c9f4346","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/Normal24.vue
// module id = null
// module chunks = 